/* eslint-disable no-unused-vars */
import { useSelector } from "react-redux";

// This hook will return the estimations for the summary matrix
const useSummaryFilters = () => {
  const { summaryFilters } = useSelector((state) => state.filters);
  const { categories, products, brands } = useSelector(
    (state) => state.catalog
  );
  const retailers = useSelector((state) => state.retailers);

  const filterScenariosData = (selectedScenariosData) => {
    if (selectedScenariosData) {
      const filteredScenariosData = { ...selectedScenariosData };
      Object.keys(filteredScenariosData).forEach((scenarioId) => {
        const scenarioEstimations = filteredScenariosData[scenarioId];
        const filtered = scenarioEstimations.filter((estimation) => {
          const filterCategories = summaryFilters?.category;
          const filterProducts = summaryFilters?.product;
          const filterBrands = summaryFilters?.brand;
          const filterRetailers = summaryFilters?.retailers;
          const estimationProduct = products[estimation.product_id];
          const estimationCategories = estimationProduct?.line?.categories;
          const estimationBrand = brands[estimationProduct?.brand_id];
          const estimationRetailer = retailers[estimation.retailer_id];
          if (
            filterCategories?.length > 0 &&
            !filterCategories?.some((filterCategory) =>
              estimationCategories?.some(
                (estimationCategory) =>
                  filterCategory?.id === estimationCategory?.id
              )
            )
          )
            return false;
          if (
            filterBrands?.length > 0 &&
            !filterBrands?.some(
              (filterBrand) => filterBrand?.id === estimationBrand?.id
            )
          )
            return false;
          if (
            filterProducts?.length > 0 &&
            !filterProducts?.some(
              (filterProduct) => filterProduct?.id === estimationProduct?.id
            )
          )
            return false;
          if (
            filterRetailers?.length > 0 &&
            !filterRetailers?.some(
              (filterData) => filterData?.id === estimationRetailer?.id
            )
          )
            return false;
          return true;
        });
        filteredScenariosData[scenarioId] = filtered;
      });
      return filteredScenariosData;
    }
    return selectedScenariosData;
  };

  return { filterScenariosData };
};

export default useSummaryFilters;
